import type { Persona } from "@/types/persona";

import { yogaInstructors } from "./yoga-pilates-instructors";
import { fitnessTrainers } from "./fitness-personal-trainers";
import { beauticians } from "./beauticians-beauty-salons";
import { massageTherapists } from "./massage-therapists";
import { consultants } from "./consultants-business-coaches";
import { hairdressers } from "./hairdressers-barbers";
import { photographers } from "./photographers-videographers";
import { nailTechnicians } from "./nail-technicians";
import { physiotherapists } from "./physiotherapists";
import { sportClubs } from "./sport-clubs";
import { psychologists } from "./psychologists-mentors";
import { nutritionists } from "./nutritionists";
import { therapistsCoaches } from "./therapists-coaches";

export const personas: Record<string, Persona> = {
  [yogaInstructors.slug]: yogaInstructors,
  [fitnessTrainers.slug]: fitnessTrainers,
  [beauticians.slug]: beauticians,
  [massageTherapists.slug]: massageTherapists,
  [consultants.slug]: consultants,
  [hairdressers.slug]: hairdressers,
  [photographers.slug]: photographers,
  [nailTechnicians.slug]: nailTechnicians,
  [physiotherapists.slug]: physiotherapists,
  [sportClubs.slug]: sportClubs,
  [psychologists.slug]: psychologists,
  [nutritionists.slug]: nutritionists,
  [therapistsCoaches.slug]: therapistsCoaches,
};

export const getPersona = (slug: string): Persona | undefined => personas[slug];
